import Button from "../Button";
import {useMobileno} from "../../api/login";
import {useNavigateTo} from "../../hooks/useNavigateTo";
import {mediaMatch} from "../../utils";
import {useDispatch} from "react-redux";
import {setDrawerRegister, setDrawerLogin, setDrawerSearch, setDrawerForgetPwd} from "../../reducer/actions";
import {useTranslation} from "react-i18next";
import Mobile from "../Mobile";
import PC from "../PC";
import cookies from "../../utils/cookies";

function ThirdParty() {
  const { t } = useTranslation();
  return null;
  return (
    <div className="mt-[15px]">
      <div className="flex items-center">
        <p className="border-b flex-none w-[25%]"></p>
        <p className="py-[30px] px-[12px] text-[#999] flex-1 text-center">
          {t('第三方登录')}
        </p>
        <p className="border-b lex-none w-[25%]"></p>
      </div>
      <div className="flex items-center justify-around">
        <a href={''}
           className="rounded-full justify-center items-center flex
                      w-[45px] h-[45px] bg-[#3B5998]">
          <i className="iconfont icon-facebook text-[26px] text-white"></i>
        </a>
        <a href={''}
           className="rounded-full justify-center items-center flex
                      w-[45px] h-[45px] bg-[#1DA1F2]">
          <i className="iconfont icon-twitter text-[26px] text-white"></i>
        </a>
        <a href={''}
           className="rounded-full justify-center items-center flex
                      w-[45px] h-[45px] bg-[#0077B5]">
          <i className="iconfont icon-linkedin text-[26px] text-white"></i>
        </a>
      </div>
    </div>
  );
}

export default function LoginForm({ children }) {
  const { t } = useTranslation();
  const { loading, query, login, inputHandle } = useMobileno();
  const dispatch = useDispatch();
  const navigateTo = useNavigateTo();
  const isMdmax = mediaMatch.isMdmax;
  const agentInfo = cookies.getAgentInfo();
  
  const gotoReg = () => {
    if (isMdmax) {
      navigateTo('/register');
    } else {
      dispatch(setDrawerRegister(true));
      dispatch(setDrawerLogin(false));
      dispatch(setDrawerSearch(false));
      dispatch(setDrawerForgetPwd(false));
    }
  };
  
  const gotoForgetPwd = () => {
    if (isMdmax) {
      navigateTo('/forgetPwd');
    } else {
      dispatch(setDrawerForgetPwd(true));
      dispatch(setDrawerRegister(false));
      dispatch(setDrawerLogin(false));
      dispatch(setDrawerSearch(false));
    }
  };
  
  return (
    children ? (children({
        t,
        query,
        loading,
        navigateTo,
        login,
        inputHandle,
        gotoForgetPwd,
        gotoReg,
      
      }))
      : <>
        <div className="mb-[15px]">
          <label className="text-[14px] hidden mb-[5px] md:block">
            {agentInfo.isAllowMobileno === '1' && t('手机号') + '/'}{t('邮箱')}
          </label>
          <input type="text"
                 placeholder={`${t('请输入')}${agentInfo.isAllowMobileno === '1'? t('手机号') + '/': '' }${t('邮箱')}`}
                 value={query.account}
                 onChange={(e) => inputHandle(e, 'account')}
                 className="p-[15px] mdmax:rounded-none container md:border border-bottom-1px border-[#d4d4d4] text-[15px]"/>
        </div>
        
        <div className="mb-[10px]">
          <label className="text-[14px] hidden mb-[5px] md:block">
            {t('密码')}
          </label>
          <input type="password"
                 placeholder={`${t('请输入')}${t('密码')}`}
                 value={query.pwd}
                 onChange={(e) => inputHandle(e, 'pwd')}
                 className="p-[15px] mdmax:rounded-none container md:border border-bottom-1px border-[#d4d4d4] text-[15px]"/>
        </div>
        
        <Mobile className="justify-between flex">
          <a className="link text-[14px]" onClick={() => navigateTo('/forgetPwd')}>{t('忘记密码')}?</a>
          <a className="link text-[14px]" onClick={() => navigateTo('/register')}>{t('注册')}</a>
        </Mobile>
        
        <Button className="rounded-none mdmax:rounded-full container text-white
                         py-[12px] bg-[#444] mb-[5px] mt-[60px] text-[14px]"
                loading={loading}
                onClick={login}>{t('登录')}</Button>
        <PC className="justify-between flex">
          <a onClick={gotoForgetPwd}
             className="link text-[#999] text-[14px]">{t('忘记密码')}?</a>
          <a onClick={gotoReg}
             className="link text-[#999] text-[14px]">{t('注册')}</a>
        </PC>
        <ThirdParty/>
      </>
  );
}
